import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { BondValidationResponse } from '../models/bond-validation.model';

export type SuretyBranch = 'aserta' | 'insurgentes';

export const ValidateSurety = createAction(
  '[SuretyValidator] Validate Surety',
  props<{ code: string }>()
);

export const ValidateSuretySuccess = createAction(
  '[SuretyValidator] Validate Surety Success',
  props<{ payload: BondValidationResponse }>()
);

export const ValidateSuretyError = createAction(
  '[SuretyValidator] Validate Surety Error',
  props<{ payload: HttpErrorResponse }>()
);

export const DownloadBondDocument = createAction(
  '[SuretyValidator] Download Bond Document',
  props<{ code: string }>()
);

export const DownloadBondCertificate = createAction(
  '[SuretyValidator] Download Bond Certificate',
  props<{ code: string; branch: SuretyBranch }>()
);

export const SetSelectedBranch = createAction(
  '[SuretyValidator] Set Selected Branch',
  props<{ branch: SuretyBranch }>()
);
